import { ProviderMention } from '@/services/types/treatment-types';

import { ProviderCard } from '../cards/ProviderCard';

interface ProvidersSectionProps {
  providers: ProviderMention[];
}

export const ProvidersSection = ({ providers }: ProvidersSectionProps) => {
  if (!providers || providers.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        No providers found in this document.
      </p>
    );
  }

  return (
    <div>
      <div className="divide-y divide-zinc-100 dark:divide-zinc-800">
        {providers.map((provider) => (
          <ProviderCard key={provider.id} entity={provider} />
        ))}
      </div>
    </div>
  );
};
